import { render, staticRenderFns } from "./PageTitleIcon.vue?vue&type=template&id=70fc1133&scoped=true&"
import script from "./PageTitleIcon.vue?vue&type=script&lang=js&"
export * from "./PageTitleIcon.vue?vue&type=script&lang=js&"
import style0 from "./PageTitleIcon.vue?vue&type=style&index=0&id=70fc1133&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fc1133",
  null
  
)

export default component.exports